import React, {Component} from 'react';
import connect from "react-redux/es/connect/connect";
import {setCurrentNavPage} from "actions";
import NotFoundPage from "../components/NotFoundPage";
import * as lottie from 'lottie-web';
import { S3_FOLDER_URL } from 'Config';


class NotFoundFrame extends Component {

    constructor(props) {
        super(props)
    }

  componentDidMount() {
    this.intiAnimation();
  }

  componentWillUnmount() {
    if (this.anim) {
      this.anim.destroy();
    }
  }

  intiAnimation = () => {
    if (this.anim) {
      this.anim.destroy();
    }

    this.anim = lottie.loadAnimation({
      container: this.refs.animationContainer,
      renderer: 'svg',
      loop: 1,
      autoplay: true,
      path: `${S3_FOLDER_URL}/billing/assets/animations/billing-header.json`,
    });
  };

  handleClickToPause = () => {
    if (!this.anim) {
      return;
    }
    if (this.anim.isPaused) {
      this.anim.goToAndPlay(0);
    } else {
      this.anim.pause();
    }
  };


  render() {
    return (
        <NotFoundPage isErrorPage={true}/>
    );
  }
}
const mapStateToProps = state => ({});

const mapDispatchToProps = {
  setCurrentNavPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(NotFoundFrame);



// WEBPACK FOOTER //
// ./app/pages/NotFoundFrame.js